<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 12:21:00
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-05 11:43:56
 * @Description: 单选组件
 * @FilePath: \hsylc2021\src\components\form\Radio\index.vue
-->
<template>
  <div class="component-radio" :class="computedClass" @click="handleClickRadio">
    <div class="component-radio-render"></div>
    <div class="component-label-render w-normal" v-html="label"></div>
  </div>
</template>
<script>
/**
 * radio 组件
 * @module Radio
 */
export default {
  name: 'Radio',
  /**
   * @prop {String} className 外部class
   * @prop {Boolean} value 数据true/false
   * @prop {String} label 选项标签
   * @prop {Boolean} reverse 是否支持反选 默认false
   * @prop {Boolean} disabled 是否禁止 默认false
   * @prop {Any} _id 唯一标识
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    reverse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    _id: null
  },
  /**
   * @prop {Object} computedClass 组件计算后的class
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret['active'] = this.value;
      ret['disabled'] = this.disabled;
      return ret;
    }
  },
  methods: {
    /**
     * @event input v-model事件
     */
    /**
     * @description 点击radio事件
     * @function handleClickRadio
     */
    handleClickRadio: function() {
      if (!this.disabled) {
        let value = !this.value;
        if (this.reverse && !value) {
          this.$emit('input', value, this._id);
        } else if (value) {
          this.$emit('input', value, this._id);
        }
      }
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
